import React, { useState, useEffect } from "react";
import "./YouTubeVideos.css";

const YouTubeVideos = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [playingVideoId, setPlayingVideoId] = useState(null);

  const mockVideoData = [
    {
      id: "yRR9KHmziDo",
      title:
        "💰 NEED FAST CASH? WE GOT YOU COVERED! bring your cars, jewelry, luxury wristwatches,",
      description: `Don’t wait — turn your assets into instant funds.  
Bring your cars, luxury watches or jewelry to Respected Solutions and let them work for you!  
Flexible terms. Confidential process. Instant approval.`,
      thumbnail: "https://img.youtube.com/vi/yRR9KHmziDo/hqdefault.jpg",
    },
    {
      id: "kl3txJEMGss",
      title:
        "Don’t sell your valuables — let them work for you At Respected Solutions, let's get you funded ASAP",
      description: `Why throw away your valuables when they can earn YOU money?  
At Respected Solutions we unlock cash against your cars, jewellery & luxury items — no hassles, full support.  
Get funded now and keep ownership.`,
      thumbnail: "https://img.youtube.com/vi/kl3txJEMGss/hqdefault.jpg",
    },
  ];

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setVideos(mockVideoData);
      setLoading(false);
    }, 1200);
  }, []);

  return (
    <section className="youtube-videos">
      <div className="youtube-videos__container">
        <div className="youtube-videos__header">
          <h2 className="youtube-videos__title">Latest YouTube Videos</h2>
          <p className="youtube-videos__subtitle">
            Watch our expert financial advice and tips
          </p>
        </div>

        <div className="youtube-videos__grid">
          {videos.map((video) => (
            <div key={video.id} className="youtube-videos__card">
              <div className="youtube-videos__thumbnail-container">
                {playingVideoId === video.id ? (
                  <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${video.id}?autoplay=1`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <>
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="youtube-videos__thumbnail"
                    />
                    <div
                      className="youtube-videos__play-overlay"
                      onClick={() => setPlayingVideoId(video.id)}
                    >
                      <div className="youtube-videos__play-button">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="youtube-videos__content">
                <h3 className="youtube-videos__video-title">{video.title}</h3>
                <p className="youtube-videos__description">
                  {video.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default YouTubeVideos;
